import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';

function AddCart_HicretKuruyemis({ item, isActive }) {
  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  return (
    <>
      <div
        style={{
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingLeft: staticValues[15],
          paddingRight: staticValues[15],
          paddingTop: staticValues[5],
          paddingBottom: staticValues[5],
          borderTopWidth: 1,
          borderTopColor: '#eee',
          shadowOffset: {
            width: 0,
            height: -2,
          },
          shadowOpacity: 0.1,
          shadowRadius: 4,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: 2,
          backgroundColor: customization?.backgroundColor,
          zIndex: 15,
        }}
      >
        <div
          style={{
            color: 'black',
            borderRadius: 5,
            paddingTop: staticValues[5],
            paddingBottom: staticValues[5],
            width: '30%',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'left',
            fontWeight: customization?.priceTextWeight,
          }}
        >
          <div style={{ fontSize: customization?.priceTextSize, color: customization?.priceTextColor }}>
            {item?.data?.priceText}
          </div>
          <div
            style={{
              fontSize: 12,
              color: '#1b2d2880',
              fontWeight: customization?.sellPriceNumberTextWeight,
              textDecoration: 'line-through',
            }}
          >
            {firstProduct?.variants?.[0]?.prices?.[0]?.currencySymbol}
            {firstProduct?.variants?.[0]?.prices?.[0]?.sellPrice?.toFixed(2)}
          </div>
          <div
            style={{
              fontSize: 20,
              color: '#377151',
              fontWeight: customization?.discountPriceNumberTextWeight,
            }}
          >
            {firstProduct?.variants?.[0]?.prices?.[0]?.currencySymbol}
            {firstProduct?.variants?.[0]?.prices?.[0]?.discountPrice?.toFixed(2)}
          </div>
        </div>
        <div
          style={{
            color: '#FFFFFF',
            backgroundColor: '#377151',
            borderRadius: 5,
            paddingLeft: staticValues[10],
            paddingRight: staticValues[10],
            paddingTop: staticValues[5],
            paddingBottom: staticValues[5],
            width: '70%',
            fontSize: customization?.buttonTextSize,
            fontWeight: customization?.buttonTextWeight,
          }}
        >
          {item?.data.buttonText}
        </div>
      </div>
    </>
  );
}

export default AddCart_HicretKuruyemis;
